{
  "data": {
    "responsiveImageStyles": [
      {
        "name": "column_fifth",
        "styles": [
          {
            "id": "300_225_focal_scale_crop",
            "viewport": "zt.fourk",
            "density": "1x"
          },
          {
            "id": "600_450_focal_scale_crop",
            "viewport": "zt.fourk",
            "density": "2x"
          },
          {
            "id": "300_225_focal_scale_crop",
            "viewport": "zt.fullhd",
            "density": "1x"
          },
          {
            "id": "600_450_focal_scale_crop",
            "viewport": "zt.fullhd",
            "density": "2x"
          },
          {
            "id": "218_164_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "1x"
          },
          {
            "id": "436_327_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "2x"
          },
          {
            "id": "400_300_focal_scale_crop",
            "viewport": "zt.desktop",
            "density": "1x"
          },
          {
            "id": "800_600_focal_scale_crop",
            "viewport": "zt.desktop",
            "density": "2x"
          },
          {
            "id": "300_225_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "1x"
          },
          {
            "id": "600_450_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "2x"
          },
          {
            "id": "160_120_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "1x"
          },
          {
            "id": "320_240_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "2x"
          }
        ]
      },
      {
        "name": "column_full",
        "styles": [
          {
            "id": "582_437_focal_scale_crop",
            "viewport": "zt.fourk",
            "density": "1x"
          },
          {
            "id": "1164_873_focal_scale_crop",
            "viewport": "zt.fourk",
            "density": "2x"
          },
          {
            "id": "582_437_focal_scale_crop",
            "viewport": "zt.fullhd",
            "density": "1x"
          },
          {
            "id": "1164_873_focal_scale_crop",
            "viewport": "zt.fullhd",
            "density": "2x"
          },
          {
            "id": "582_437_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "1x"
          },
          {
            "id": "1164_873_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "2x"
          },
          {
            "id": "480_360_focal_scale_crop",
            "viewport": "zt.desktop",
            "density": "1x"
          },
          {
            "id": "960_720_focal_scale_crop",
            "viewport": "zt.desktop",
            "density": "2x"
          },
          {
            "id": "348_261_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "1x"
          },
          {
            "id": "696_522_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "2x"
          },
          {
            "id": "343_257_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "1x"
          },
          {
            "id": "686_515_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "2x"
          }
        ]
      },
      {
        "name": "column_half",
        "styles": [
          {
            "id": "582_437_focal_scale_crop",
            "viewport": "zt.fourk",
            "density": "1x"
          },
          {
            "id": "1164_873_focal_scale_crop",
            "viewport": "zt.fourk",
            "density": "2x"
          },
          {
            "id": "582_437_focal_scale_crop",
            "viewport": "zt.fullhd",
            "density": "1x"
          },
          {
            "id": "1164_873_focal_scale_crop",
            "viewport": "zt.fullhd",
            "density": "2x"
          },
          {
            "id": "582_437_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "1x"
          },
          {
            "id": "1164_873_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "2x"
          },
          {
            "id": "480_360_focal_scale_crop",
            "viewport": "zt.desktop",
            "density": "1x"
          },
          {
            "id": "960_720_focal_scale_crop",
            "viewport": "zt.desktop",
            "density": "2x"
          },
          {
            "id": "348_261_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "1x"
          },
          {
            "id": "696_522_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "2x"
          },
          {
            "id": "343_257_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "1x"
          },
          {
            "id": "686_515_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "2x"
          }
        ]
      },
      {
        "name": "column_quarter",
        "styles": [
          {
            "id": "300_225_focal_scale_crop",
            "viewport": "zt.fourk",
            "density": "1x"
          },
          {
            "id": "600_450_focal_scale_crop",
            "viewport": "zt.fourk",
            "density": "2x"
          },
          {
            "id": "300_225_focal_scale_crop",
            "viewport": "zt.fullhd",
            "density": "1x"
          },
          {
            "id": "600_450_focal_scale_crop",
            "viewport": "zt.fullhd",
            "density": "2x"
          },
          {
            "id": "279_209_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "1x"
          },
          {
            "id": "558_419_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "2x"
          },
          {
            "id": "400_300_focal_scale_crop",
            "viewport": "zt.desktop",
            "density": "1x"
          },
          {
            "id": "800_600_focal_scale_crop",
            "viewport": "zt.desktop",
            "density": "2x"
          },
          {
            "id": "300_225_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "1x"
          },
          {
            "id": "600_450_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "2x"
          },
          {
            "id": "343_257_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "1x"
          },
          {
            "id": "686_515_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "2x"
          }
        ]
      },
      {
        "name": "column_third",
        "styles": [
          {
            "id": "380_285_focal_scale_crop",
            "viewport": "zt.fourk",
            "density": "1x"
          },
          {
            "id": "760_570_focal_scale_crop",
            "viewport": "zt.fourk",
            "density": "2x"
          },
          {
            "id": "380_285_focal_scale_crop",
            "viewport": "zt.fullhd",
            "density": "1x"
          },
          {
            "id": "760_570_focal_scale_crop",
            "viewport": "zt.fullhd",
            "density": "2x"
          },
          {
            "id": "380_285_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "1x"
          },
          {
            "id": "760_570_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "2x"
          },
          {
            "id": "400_300_focal_scale_crop",
            "viewport": "zt.desktop",
            "density": "1x"
          },
          {
            "id": "800_600_focal_scale_crop",
            "viewport": "zt.desktop",
            "density": "2x"
          },
          {
            "id": "300_225_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "1x"
          },
          {
            "id": "600_450_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "2x"
          },
          {
            "id": "343_257_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "1x"
          },
          {
            "id": "686_515_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "2x"
          }
        ]
      },
      {
        "name": "content_fullwidth",
        "styles": [
          {
            "id": "1216_684_focal_scale_crop",
            "viewport": "zt.fullhd",
            "density": "1x"
          },
          {
            "id": "2432_1368_focal_scale_crop",
            "viewport": "zt.fullhd",
            "density": "2x"
          },
          {
            "id": "1216_684_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "1x"
          },
          {
            "id": "2432_1368_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "2x"
          },
          {
            "id": "1024_768_focal_scale_crop",
            "viewport": "zt.desktop",
            "density": "1x"
          },
          {
            "id": "2048_1536_focal_scale_crop",
            "viewport": "zt.desktop",
            "density": "2x"
          },
          {
            "id": "768_576_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "1x"
          },
          {
            "id": "1536_1152_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "2x"
          },
          {
            "id": "375_281_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "1x"
          },
          {
            "id": "750_563_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "2x"
          }
        ]
      },
      {
        "name": "content_fullwidth_4_3",
        "styles": [
          {
            "id": "1216_912_focal_scale_crop",
            "viewport": "zt.fullhd",
            "density": "1x"
          },
          {
            "id": "2432_1824_focal_scale_crop",
            "viewport": "zt.fullhd",
            "density": "2x"
          },
          {
            "id": "1216_912_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "1x"
          },
          {
            "id": "2432_1824_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "2x"
          },
          {
            "id": "1024_768_focal_scale_crop",
            "viewport": "zt.desktop",
            "density": "1x"
          },
          {
            "id": "2048_1536_focal_scale_crop",
            "viewport": "zt.desktop",
            "density": "2x"
          },
          {
            "id": "768_576_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "1x"
          },
          {
            "id": "1536_1152_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "2x"
          },
          {
            "id": "375_281_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "1x"
          },
          {
            "id": "750_563_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "2x"
          }
        ]
      },
      {
        "name": "grid_small",
        "styles": [
          {
            "id": "300_300_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "1x"
          },
          {
            "id": "300_300_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "2x"
          },
          {
            "id": "186_186_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "1x"
          },
          {
            "id": "186_186_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "2x"
          },
          {
            "id": "60_60_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "1x"
          },
          {
            "id": "60_60_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "2x"
          }
        ]
      },
      {
        "name": "hero",
        "styles": [
          {
            "id": "1920_1080_focal_scale_crop",
            "viewport": "zt.fourk",
            "density": "1x"
          },
          {
            "id": "3840_2160_focal_scale_crop",
            "viewport": "zt.fourk",
            "density": "2x"
          },
          {
            "id": "1408_792_focal_scale_crop",
            "viewport": "zt.fullhd",
            "density": "1x"
          },
          {
            "id": "2816_1584_focal_scale_crop",
            "viewport": "zt.fullhd",
            "density": "2x"
          },
          {
            "id": "1216_684_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "1x"
          },
          {
            "id": "2432_1368_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "2x"
          },
          {
            "id": "1024_576_focal_scale_crop",
            "viewport": "zt.desktop",
            "density": "1x"
          },
          {
            "id": "2048_1152_focal_scale_crop",
            "viewport": "zt.desktop",
            "density": "2x"
          },
          {
            "id": "768_432_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "1x"
          },
          {
            "id": "1536_864_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "2x"
          },
          {
            "id": "375_625_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "1x"
          },
          {
            "id": "750_1250_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "2x"
          }
        ]
      },
      {
        "name": "image_gallery",
        "styles": [
          {
            "id": "693_520_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "1x"
          },
          {
            "id": "1386_1040_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "2x"
          },
          {
            "id": "676_507_focal_scale_crop",
            "viewport": "zt.desktop",
            "density": "1x"
          },
          {
            "id": "1352_1014_focal_scale_crop",
            "viewport": "zt.desktop",
            "density": "2x"
          },
          {
            "id": "564_423_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "1x"
          },
          {
            "id": "1128_846_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "2x"
          },
          {
            "id": "280_210_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "1x"
          },
          {
            "id": "560_420_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "2x"
          }
        ]
      },
      {
        "name": "page_hero",
        "styles": [
          {
            "id": "1920_1244_focal_scale_crop",
            "viewport": "zt.fourk",
            "density": "1x"
          },
          {
            "id": "3840_1244_focal_scale_crop",
            "viewport": "zt.fourk",
            "density": "2x"
          },
          {
            "id": "1408_1200_focal_scale_crop",
            "viewport": "zt.fullhd",
            "density": "1x"
          },
          {
            "id": "2816_1200_focal_scale_crop",
            "viewport": "zt.fullhd",
            "density": "2x"
          },
          {
            "id": "1216_880_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "1x"
          },
          {
            "id": "2432_880_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "2x"
          },
          {
            "id": "1024_768_focal_scale_crop",
            "viewport": "zt.desktop",
            "density": "1x"
          },
          {
            "id": "2048_768_focal_scale_crop",
            "viewport": "zt.desktop",
            "density": "2x"
          },
          {
            "id": "768_1024_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "1x"
          },
          {
            "id": "1536_1024_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "2x"
          },
          {
            "id": "375_770_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "1x"
          },
          {
            "id": "750_770_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "2x"
          }
        ]
      },
      {
        "name": "sidebar_right",
        "styles": [
          {
            "id": "380_285_focal_scale_crop",
            "viewport": "zt.fourk",
            "density": "1x"
          },
          {
            "id": "760_570_focal_scale_crop",
            "viewport": "zt.fourk",
            "density": "2x"
          },
          {
            "id": "380_285_focal_scale_crop",
            "viewport": "zt.fullhd",
            "density": "1x"
          },
          {
            "id": "760_570_focal_scale_crop",
            "viewport": "zt.fullhd",
            "density": "2x"
          },
          {
            "id": "380_285_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "1x"
          },
          {
            "id": "760_570_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "2x"
          },
          {
            "id": "400_300_focal_scale_crop",
            "viewport": "zt.desktop",
            "density": "1x"
          },
          {
            "id": "800_600_focal_scale_crop",
            "viewport": "zt.desktop",
            "density": "2x"
          },
          {
            "id": "300_225_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "1x"
          },
          {
            "id": "600_450_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "2x"
          },
          {
            "id": "343_257_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "1x"
          },
          {
            "id": "686_515_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "2x"
          }
        ]
      },
      {
        "name": "teaser",
        "styles": [
          {
            "id": "582_437_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "1x"
          },
          {
            "id": "1164_873_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "2x"
          },
          {
            "id": "480_360_focal_scale_crop",
            "viewport": "zt.desktop",
            "density": "1x"
          },
          {
            "id": "960_720_focal_scale_crop",
            "viewport": "zt.desktop",
            "density": "2x"
          },
          {
            "id": "414_311_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "1x"
          },
          {
            "id": "828_621_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "2x"
          },
          {
            "id": "343_257_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "1x"
          },
          {
            "id": "686_515_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "2x"
          }
        ]
      },
      {
        "name": "teaser_medium",
        "styles": [
          {
            "id": "582_437_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "1x"
          },
          {
            "id": "1164_873_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "2x"
          },
          {
            "id": "480_360_focal_scale_crop",
            "viewport": "zt.desktop",
            "density": "1x"
          },
          {
            "id": "960_720_focal_scale_crop",
            "viewport": "zt.desktop",
            "density": "2x"
          },
          {
            "id": "352_264_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "1x"
          },
          {
            "id": "704_528_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "2x"
          },
          {
            "id": "343_257_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "1x"
          },
          {
            "id": "686_515_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "2x"
          }
        ]
      },
      {
        "name": "teaser_small",
        "styles": [
          {
            "id": "160_120_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "1x"
          },
          {
            "id": "320_240_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "2x"
          },
          {
            "id": "228_171_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "1x"
          },
          {
            "id": "456_342_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "2x"
          },
          {
            "id": "480_360_focal_scale_crop",
            "viewport": "zt.desktop",
            "density": "1x"
          },
          {
            "id": "960_720_focal_scale_crop",
            "viewport": "zt.desktop",
            "density": "2x"
          },
          {
            "id": "276_207_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "1x"
          },
          {
            "id": "552_414_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "2x"
          },
          {
            "id": "280_auto_focal_scale_crop",
            "viewport": "zt.fullhd",
            "density": "1x"
          },
          {
            "id": "560_auto_focal_scale_crop",
            "viewport": "zt.fullhd",
            "density": "2x"
          }
        ]
      },
      {
        "name": "test_fullwidth",
        "styles": [
          {
            "id": "test_fullwidth_large",
            "viewport": "zt.fourk",
            "density": "1x"
          },
          {
            "id": "test_fullwidth_large",
            "viewport": "zt.fullhd",
            "density": "1x"
          },
          {
            "id": "test_fullwidth_large",
            "viewport": "zt.widescreen",
            "density": "1x"
          },
          {
            "id": "test_fullwidth_large",
            "viewport": "zt.desktop",
            "density": "1x"
          },
          {
            "id": "test_fullwidth_small",
            "viewport": "zt.tablet",
            "density": "1x"
          },
          {
            "id": "test_fullwidth_small",
            "viewport": "zt.mobile_tablet",
            "density": "1x"
          },
          {
            "id": "test_fullwidth_small",
            "viewport": "zt.mobile",
            "density": "1x"
          }
        ]
      },
      {
        "name": "text_image_box",
        "styles": [
          {
            "id": "683_512_focal_scale_crop",
            "viewport": "zt.fourk",
            "density": "1x"
          },
          {
            "id": "1366_1025_focal_scale_crop",
            "viewport": "zt.fourk",
            "density": "2x"
          },
          {
            "id": "683_512_focal_scale_crop",
            "viewport": "zt.fullhd",
            "density": "1x"
          },
          {
            "id": "1366_1025_focal_scale_crop",
            "viewport": "zt.fullhd",
            "density": "2x"
          },
          {
            "id": "683_512_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "1x"
          },
          {
            "id": "1366_1025_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "2x"
          },
          {
            "id": "564_423_focal_scale_crop",
            "viewport": "zt.desktop",
            "density": "1x"
          },
          {
            "id": "1128_846_focal_scale_crop",
            "viewport": "zt.desktop",
            "density": "2x"
          },
          {
            "id": "414_311_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "1x"
          },
          {
            "id": "828_621_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "2x"
          },
          {
            "id": "343_257_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "1x"
          },
          {
            "id": "686_515_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "2x"
          }
        ]
      },
      {
        "name": "viewport_full",
        "styles": [
          {
            "id": "1680_945_focal_scale_crop",
            "viewport": "zt.fullhd",
            "density": "1x"
          },
          {
            "id": "3360_1890_focal_scale_crop",
            "viewport": "zt.fullhd",
            "density": "2x"
          },
          {
            "id": "1216_684_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "1x"
          },
          {
            "id": "2432_1368_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "2x"
          },
          {
            "id": "1024_768_focal_scale_crop",
            "viewport": "zt.desktop",
            "density": "1x"
          },
          {
            "id": "2048_1536_focal_scale_crop",
            "viewport": "zt.desktop",
            "density": "2x"
          },
          {
            "id": "768_576_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "1x"
          },
          {
            "id": "1536_1152_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "2x"
          },
          {
            "id": "375_281_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "1x"
          },
          {
            "id": "750_563_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "2x"
          }
        ]
      },
      {
        "name": "hero_slider",
        "styles": [
          {
            "id": "1920_1152_focal_scale_crop",
            "viewport": "zt.fourk",
            "density": "1x"
          },
          {
            "id": "3840_2304_focal_scale_crop",
            "viewport": "zt.fourk",
            "density": "2x"
          },
          {
            "id": "1408_844_focal_scale_crop",
            "viewport": "zt.fullhd",
            "density": "1x"
          },
          {
            "id": "2816_1688_focal_scale_crop",
            "viewport": "zt.fullhd",
            "density": "2x"
          },
          {
            "id": "1216_730_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "1x"
          },
          {
            "id": "2432_1458_focal_scale_crop",
            "viewport": "zt.widescreen",
            "density": "2x"
          },
          {
            "id": "1024_614_focal_scale_crop",
            "viewport": "zt.desktop",
            "density": "1x"
          },
          {
            "id": "2048_1228_focal_scale_crop",
            "viewport": "zt.desktop",
            "density": "2x"
          },
          {
            "id": "768_460_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "1x"
          },
          {
            "id": "1536_922_focal_scale_crop",
            "viewport": "zt.tablet",
            "density": "2x"
          },
          {
            "id": "375_225_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "1x"
          },
          {
            "id": "750_450_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "2x"
          }
        ]
      },
      {
        "name": "employee_portrait",
        "styles": [
          {
            "id": "560_560_focal_scale_crop",
            "viewport": "zt.mobile",
            "density": "2x"
          }
        ]
      }
    ]
  }
}
